<nav class="navbar navbar-expand-md navbar-dark menu-header">
  <div class="navbar-brand">
    <span (click)="!userData.organisation && onChangeOrganisation()"
          [class]="{'org-title': !userData.name}">{{userData.organisationName ? userData.organisationName : sharedService.currentOrganisation.name}}
      - </span>
    <span>Permits</span>
  </div>

  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown" aria-expanded="true" aria-label="Toggle navigation" (click)="toggleCollapsed()">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown" [ngClass]="{'show': collapsed }">
    <ul class="navbar-nav mr-auto">
    </ul>
    <ul class="navbar-nav" >
      <li class="nav-item" (click)="toggleCollapsed()">
        <a class="nav-link menu" href="javascript:" routerLinkActive="active" [routerLink]="['home']">Home</a>
      </li>
      <li class="nav-item none">
        <a class="nav-link menu" href="javascript:" routerLinkActive="active" [routerLink]="['qpa']">Quick Setup</a>
      </li>
      <li class="nav-item" (click)="toggleCollapsed()">
        <div class="menu nav-link" [routerLink]="['plants']" routerLinkActive="active"> Plants</div>
      </li>
      <li class="nav-item" (click)="toggleCollapsed()">
        <div class="menu nav-link" [routerLink]="['permits']" routerLinkActive="active"> Permits</div>
      </li>
      <li class="nav-item" (click)="toggleCollapsed()">
        <div class="menu nav-link" [routerLink]="['inspections']" routerLinkActive="active"> Inspections</div>
      </li>
      <li class="nav-item dropdown" (click)="toggleCollapsed()">
        <div class="menu nav-link" href="menu nav-link" [routerLink]="['reports']" routerLinkActive="active"> Report <i
          class="fa" aria-hidden="true"></i></div>
      </li>
      <li class="nav-item" (click)="toggleCollapsed()">
        <div class="menu nav-link" [routerLink]="['dashboard']" routerLinkActive="active"> Dashboard</div>
      </li>
      <li class="nav-item dropdown none" *ngIf="userData.level < 4">
        <div class="menu nav-link" href="menu nav-link" [routerLink]="['tracking']" routerLinkActive="active"> Site view
          <i
            class="fa" aria-hidden="true"></i></div>
      </li>
      <li class="nav-item dropdown">
        <div class="menu nav-link" [ngClass]="{active: router.url.indexOf('references') > -1}"
             [matMenuTriggerFor]="refMenu"> References <i
          class="fa fa-caret-down" aria-hidden="true"></i></div>

        <mat-menu #refMenu="matMenu" class="dropdown-content">
          <button mat-menu-item [routerLink]="['./references/golden-rules']" routerLinkActive="menu-active"  (click)="toggleCollapsed()">Golden
            rules
          </button>
          <button mat-menu-item [routerLink]="['./references/policy-procedures']" routerLinkActive="menu-active" (click)="toggleCollapsed()">Policy
            and procedure
          </button>
          <button mat-menu-item [routerLink]="['./references/documents']" routerLinkActive="menu-active" (click)="toggleCollapsed()">Documents
          </button>
          <button mat-menu-item [routerLink]="['./references/links']" routerLinkActive="menu-active" (click)="toggleCollapsed()">Links</button>
        </mat-menu>
      </li>
      <li class="nav-item">
        <button class="logout-button menu" mat-icon-button [matMenuTriggerFor]="menu"
                aria-label="Example icon-button with a menu">
          <mat-icon class="profile-icon" *ngIf="userData.profileImage?.fileUrl"><img
            [src]="userData.profileImage?.fileUrl" height="100%" width="100%" style="border-radius: 50%"></mat-icon>
          <mat-icon *ngIf="!userData.profileImage?.fileUrl">person</mat-icon>
          <i class="fa fa-caret-down profile-options-caret" aria-hidden="true"></i>
          <mat-menu #menu="matMenu">
            <button mat-menu-item title="click here to update your info and passwords" routerLink="/permit-app/manage/profile/view"
                    routerLinkActive="menu-active" (click)="toggleCollapsed()">
              <span><i class="fa fa-user" aria-hidden="true"> </i> &nbsp; &nbsp; {{userData.name}} </span>
            </button>
            <button mat-menu-item routerLink="/permit-app/manage/" routerLinkActive="menu-active"
                    *ngIf="userData.level === 1" (click)="toggleCollapsed()">
              <span><i class="fa fa-user" aria-hidden="true"> </i> &nbsp; &nbsp; Organisations </span>
            </button>
            <button mat-menu-item routerLink="/permit-app/qpa" routerLinkActive="menu-active" (click)="toggleCollapsed()">
              <span><i class="fa fa-file-text" aria-hidden="true"> </i> &nbsp; &nbsp; Quick Setup </span>
            </button>
            <button mat-menu-item routerLink="/permit-app/reports/list/archived" routerLinkActive="menu-active" (click)="toggleCollapsed()">
              <span><i class="fa fa-archive" aria-hidden="true"> </i> &nbsp; &nbsp; Archived Plants/Permits </span>
            </button>
            <button mat-menu-item routerLink="/permit-app/tracking" routerLinkActive="menu-active" (click)="toggleCollapsed()">
              <span><i class="fa fa-map-marker" aria-hidden="true"> </i> &nbsp; &nbsp; Site View </span>
            </button>
            <button mat-menu-item routerLink="/permit-app/manage/users/list" routerLinkActive="menu-active"
                    *ngIf="userData.level !== 5" (click)="toggleCollapsed()">
              <span><i class="fa fa-users" aria-hidden="true"> </i> &nbsp; &nbsp; Users </span>
            </button>
            <button mat-menu-item (click)="logOutAll()">
              <span><i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp; &nbsp; Logout All Devices</span>
            </button>
            <button mat-menu-item (click)="logOut()">
              <span><i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp; &nbsp; Logout</span>
            </button>
            <div style="border-top:2px dotted">
              <div><i>{{userData.email}}</i></div>
              <div><i>Level {{userData.level}} user</i></div>
            </div>
          </mat-menu>
        </button>
      </li>
    </ul>
  </div>
</nav>
